module.exports = __webpack_public_path__ + "img/5.69688441.png";